import { ApplicationFormAnswers, FeatureSwitches } from '../components/ApplicationForm/ApplicationFormContext'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapAnswers = (answers: Record<string, any>, featureSwitches: FeatureSwitches): ApplicationFormAnswers => ({
  addressHistory: { ...answers.addressHistory },
  contactNumber: mapContactInfo(answers, featureSwitches),
  drivingLicence: answers.drivingLicence,
  emailAddress: (featureSwitches.personalDetailsV4_2)
    ? answers.contactInfo.emailAddress : answers.groupedQuestionsForReorderingCase.emailAddress,
  employmentHistory: { ...answers.employmentHistory },
  loanAmount: answers.loanAmount,
  maritalStatus: answers.maritalStatus,
  monthlyIncome: answers.monthlyIncome,
  personalDetails: {
    dateOfBirth: answers.dateOfBirth,
    firstName: answers.groupedQuestionsForReorderingCase.firstName,
    surname: answers.groupedQuestionsForReorderingCase.surname
  },
  title: answers.groupedQuestionsForReorderingCase.title ?? answers.title,
  vehicleType: answers.vehicleType
})

const mapContactInfo = (answers: Record<string, any>, featureSwitches: FeatureSwitches) => {
  if (featureSwitches.personalDetailsV4_2) return answers.contactInfo.contactNumber
  return answers.groupedQuestionsForReorderingCase.contactNumber
}

